import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import config from '../config';

export default function useAccessToken() {
  const { instance, accounts, inProgress } = useMsal();
  const [accessToken, setAccessToken] = useState();
  useEffect(() => {
    if (inProgress === 'none' && accounts.length > 0) {
      // Retrieve an access token
      instance
        .acquireTokenSilent({
          account: accounts[0],
          scopes: [`api://${process.env.REACT_APP_AZ_CLIENT_ID}/nld.access.all`]
        })
        .then((response) => {
          if (response.accessToken) {
            setAccessToken(response.accessToken);
            config.saveTokenLocalStorage(response.accessToken);
          }
        });
    }
  }, [inProgress, accounts, instance]);

  return accessToken;
}
